import React from "react";
import { FaHeart, FaLayerGroup, FaShieldAlt, FaTags } from "react-icons/fa";
import { GiBlackBelt } from "react-icons/gi";

function StatCard({ icon: Icon, label, value, description }) {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05]">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-sky-700 shadow-sm dark:bg-white/10 dark:text-sky-200">
          <Icon />
        </div>

        <div>
          <p className="text-2xl font-bold text-slate-950 dark:text-white">
            {value}
          </p>
          <p className="text-sm font-bold text-slate-700 dark:text-white/80">
            {label}
          </p>
          {description && (
            <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

function TechniquesStats({ stats }) {
  return (
    <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
      <StatCard
        icon={FaLayerGroup}
        label="Techniques"
        value={stats.total}
        description="Base complète"
      />

      <StatCard
        icon={GiBlackBelt}
        label="UV2"
        value={stats.uv2}
        description="Techniques avec fiche"
      />

      <StatCard
        icon={FaTags}
        label="Familles"
        value={stats.families}
        description="Groupes techniques"
      />

      <StatCard
        icon={FaShieldAlt}
        label="Self-défense"
        value={stats.selfDefense}
        description="Techniques spécifiques"
      />

      <StatCard
        icon={FaHeart}
        label="Favoris"
        value={stats.favorites}
        description="Révisions personnelles"
      />
    </div>
  );
}

export default TechniquesStats;